import { AdditionalDocumentType } from '@/shared/types/additional-document-type';
import { AppointmentCancellationType } from '@/shared/types/appointment-cancellation-type';
import { AppointmentExecutorType } from '@/shared/types/appointment-executor-type';
import { AppointmentNoInstructionType } from '@/shared/types/appointment-no-instruction-type';
import { AppointmentOutcomeType } from '@/shared/types/appointment-outcome-type';
import { AppointmentPaymentStatusType } from '@/shared/types/appointment-payment-status-type';
import { AppointmentProductType } from '@/shared/types/appointment-product-type';
import { AppointmentReasonType } from '@/shared/types/appointment-reason-type';
import { AppointmentType } from '@/shared/types/appointment-type';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { ClientRelationshipType } from '@/shared/types/client-relationship-type';
import { ClientStatusType } from '@/shared/types/client-status-type';
import { ClientTitleType } from '@/shared/types/client-title-type';
import { InteractionLetterType } from '@/shared/types/interaction-letter-type';
import { InteractionOutcomeType } from '@/shared/types/interaction-outcome-type';
import { InteractionType } from '@/shared/types/interaction-type';
import { PartnerPracticeType } from '@/shared/types/partner-practice-type';
import { PowerOfAttorneyType } from '@/shared/types/power-of-attorney-type';
import { WillType } from '@/shared/types/will-type';
import { State } from '@/stores/types/state';
import { MutationTree } from 'vuex';

export class Mutations implements MutationTree<State> {
    [key: string]: (state: State, payload: any) => any;

    public setAdditionalDocumentTypes = (state: State, types: Array<AdditionalDocumentType>) => {
        state.additionalDocumentTypes = types;
    }

    public setAppointmentCancellationTypes = (state: State, types: Array<AppointmentCancellationType>) => {
        state.appointmentCancellationTypes = types;
    }

    public setAppointmentExecutorTypes = (state: State, types: Array<AppointmentExecutorType>) => {
        state.appointmentExecutorTypes = types;
    }

    public setAppointmentReasonTypes = (state: State, types: Array<AppointmentReasonType>) => {
        state.appointmentReasonTypes = types;
    }

    public setAppointmentNoInstructionTypes = (state: State, types: Array<AppointmentNoInstructionType>) => {
        state.appointmentNoInstructionTypes = types;
    }

    public setAppointmentOutcomeTypes = (state: State, types: Array<AppointmentOutcomeType>) => {
        state.appointmentOutcomeTypes = types;
    }

    public setAppointmentPaymentStatusTypes = (state: State, types: Array<AppointmentPaymentStatusType>) => {
        state.appointmentPaymentStatusTypes = types;
    }

    public setAppointmentProductTypes = (state: State, types: Array<AppointmentProductType>) => {
        state.appointmentProductTypes = types;
    }

    public setAppointmentTypes = (state: State, types: Array<AppointmentType>) => {
        state.appointmentTypes = types;
    }

    public setClientOriginalSourceTypes = (state: State, types: Array<ClientOriginalSourceType>) => {
        state.clientOriginalSourceTypes = types;
    }

    public setClientRelationshipTypes = (state: State, types: Array<ClientRelationshipType>) => {
        state.clientRelationshipTypes = types;
    }

    public setClientStatusTypes = (state: State, types: Array<ClientStatusType>) => {
        state.clientStatusTypes = types;
    }

    public setClientTitleTypes = (state: State, types: Array<ClientTitleType>) => {
        state.clientTitleTypes = types;
    }

    public setInteractionLetterTypes = (state: State, types: Array<InteractionLetterType>) => {
        state.interactionLetterTypes = types;
    }

    public setInteractionOutcomeTypes = (state: State, types: Array<InteractionOutcomeType>) => {
        state.interactionOutcomeTypes = types;
    }

    public setInteractionTypes = (state: State, types: Array<InteractionType>) => {
        state.interactionTypes = types;
    }

    public setPartnerPracticeTypes = (state: State, types: Array<PartnerPracticeType>) => {
        state.partnerPracticeTypes = types;
    }

    public setPowerOfAttorneyTypes = (state: State, types: Array<PowerOfAttorneyType>) => {
        state.powerOfAttorneyTypes = types;
    }

    public setWillTypes = (state: State, types: Array<WillType>) => {
        state.willTypes = types;
    }
}
